var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_22009)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5001 3.51367C7.76872 3.51367 3.92871 7.35384 3.92871 12.0847C3.92871 16.8164 7.76872 20.6565 12.5001 20.6565C17.2316 20.6565 21.0716 16.8164 21.0716 12.0847C21.0716 7.35384 17.2316 3.51367 12.5001 3.51367Z",
    fill: "#F74848"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9775 15.7048C10.9775 14.8649 11.6611 14.1821 12.5002 14.1821C13.3392 14.1821 14.0228 14.8649 14.0228 15.7048C14.0228 16.5447 13.3392 17.2275 12.5002 17.2275C11.6603 17.2275 10.9775 16.5439 10.9775 15.7048ZM11.5132 6.5545H13.488L13.4871 12.2734H11.5124L11.5132 8.29865V6.5545Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_22009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.0849609)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.4dd19bdc5d4896d46f6b8284c9e2ff98.svg";
export { ForwardRef as ReactComponent };